import React, { useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faDownload, faTrash } from '@fortawesome/free-solid-svg-icons';

const baseButtonStyle = {
  background: 'none',
  borderRadius: '6px',
  padding: '6px 8px',
  marginLeft: '4px',
  marginRight: '4px',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  transition: 'background 0.2s',
  border: '1px solid #d1d5db',
};

const ActionButton = ({
  color,
  icon,
  onClick,
  title,
}) => (
  <button
    style={{ ...baseButtonStyle, border: `1px solid ${color}`, color }}
    title={title}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={icon} />
  </button>
);

const StudentDocuments = ({
  test_group_user_id: testGroupUserId,
  test_group_id: testGroupId,
  ...props
}) => {
  const [uploads, setUploads] = useState(props.uploads || []);

  const handleView = (upload) => {
    window.open(upload.document_url, '_blank', 'noopener');
  };

  const handleDownload = (upload) => {
    window.open(upload.download_url, '_blank', 'noopener');
  };

  const handleDelete = async (upload) => {
    if (!window.confirm(`Are you sure you want to delete "${upload.document_name}"?`)) return;
    try {
      const response = await axios.delete(`/test_groups/${testGroupId}/schools/student_uploads/${testGroupUserId}/student_uploads/${upload.id}`);
      if (response.status === 200) {
        setUploads(uploads.filter(u => u.id !== upload.id));
      } else {
        const data = response.data;
        alert(data.errors ? data.errors.join(', ') : 'Failed to delete.');
      }
    } catch (e) {
      alert('Failed to delete.');
    }
  };

  return (
    <div className="p-4">
      <table
        style={{
          background: '#fff',
          borderCollapse: 'collapse',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
          overflow: 'hidden',
          width: '100%',
        }}>
        <thead>
          <tr
            style={{
              background: '#f6f7fb',
              textAlign: 'left',
            }}>
            <th className="px-4 py-2 body-medium-bold">Document name</th>
            <th className="px-4 py-2 body-medium-bold">Uploaded by</th>
            <th className="px-4 py-2 body-medium-bold">Upload date</th>
            <th className="px-4 py-2 body-medium-bold"></th>
          </tr>
        </thead>
        <tbody>
          {uploads.map((upload, idx) => (
            <tr
              key={upload.id}
              style={{
                background: idx % 2 === 0 ? '#fff' : '#f9f9fb',
                borderBottom: '1px solid #eee',
              }}
            >
              <td className="px-4 py-2 font-medium">{upload.document_name}</td>
              <td className="px-4 py-2">{upload.uploaded_by}</td>
              <td className="px-4 py-2">{upload.upload_date}</td>
              <td className="px-4 py-2 min-w-[120px]">
                <ActionButton
                  title="View"
                  color={"#2563eb"}
                  onClick={() => handleView(upload)}
                  icon={faEye}
                />
                <ActionButton
                  title="Download"
                  color={"#0f172a"}
                  onClick={() => handleDownload(upload)}
                  icon={faDownload}
                />
                <ActionButton
                  title="Delete"
                  color={"#dc2626"}
                  onClick={() => handleDelete(upload)}
                  icon={faTrash}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StudentDocuments;